import { IReleaseNote } from "../types"

export const RELEASE_1_3_1: IReleaseNote = {
    status: "PAST",
    title: "v1.3.1",
    date: "26th July 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "We are excited to announce ENA Connect Direct 1.3.1 was released on 26th July 2024. This is a patch release and it contains improvements to make the site better for some users. These notes outline the key changes. ",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "you can now enter a value greater than or equal to zero for 'energy storage capacity' for a battery application",
                "we have improved the clarity of one the the possible error codes you might see when trying to invite people to join your team",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been added:",
            bullets: [
                "you can now enter a value greater than or equal to zero for 'energy storage capacity' for a battery application",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "The following change has been added:",
            bullets: [
                "we have improved the clarity of one the the possible error codes you might see when trying to invite people to join your team",
            ],
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
